import React, { FC, ReactNode, useState } from 'react';
import { StyledMenuCardButton } from './styles';

export interface ItemPropTypes {
	setTrackIsActive: any;
	setActiveItem: any;
	activeItem: number;
	positions: any;
	children: ReactNode;
	index: number;
}

const Item: FC<ItemPropTypes> = ({
	setTrackIsActive,
	setActiveItem,
	activeItem,
	positions,
	children,
	index,
}) => {
	const [userDidTab, setUserDidTab] = useState(false);

	const handleFocus = () => setTrackIsActive(true);

	const handleBlur = () => {
		if (userDidTab && index + 1 === positions.length) {
			setTrackIsActive(false);
		}
		setUserDidTab(false);
	};

	const handleKeyUp = (event: any) =>
		event.key === 'Tab' &&
		!(activeItem === positions.length) &&
		setActiveItem(index);

	const handleKeyDown = (event: any) =>
		event.key === 'Tab' && setUserDidTab(true);

	return (
		<StyledMenuCardButton
			type="button"
			onFocus={handleFocus}
			onBlur={handleBlur}
			onKeyUp={handleKeyUp}
			onKeyDown={handleKeyDown}
			tabIndex={index}
		>
			{children}
		</StyledMenuCardButton>
	);
};

export default Item;
